import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    projectName: "医药云课堂PC", // 项目名称 医药云课堂PC 云课堂 新陆
    interfacePath: "", // 储存接口路径的数据
    loginRecord: "", // 储存login接口返回的数据
    editableOrNot: true, // 储存是否可编辑状态
    tokenCode: "", // 储存token
    courseListRecord: "", // 储存我的课程列表的数据
    sharedListRecord: "", // 储存共享课程列表的数据
    classListRecord: "", // 储存课次列表的数据
    courseDetails: "", // 储存课程id
    textbookDetails: "", // 储存教材
    classTimesId: "", // 储存当前课程课次id
    resourceListRecord: "", // 储存资源列表
    classTimesResources: "", // 储存当前选中课程课次资源
    questionBankData: [], // 储存当前选择题库的数据
    testPaperClassNumData: [], // 储存作业所属课次
    testPaperNameData: "", // 储存作业名称
    resourceType: "assets", // 储存资源类型
    currentType: "首页", // 储存首页当前类型
    examinationMessage: {}, // 储存线上考试信息
  },
  getters: {},
  mutations: {
    // 储存接口路径的数据
    GET_InterfacePath(state, data) {
      state.interfacePath = data;
    },
    // 储存login接口返回的数据
    GET_RES(state, data) {
      state.loginRecord = data;
    },
    // 储存是否可编辑状态
    GET_EditableOrNot(state, data) {
      state.editableOrNot = data;
    },
    // 储存token
    GET_Token(state, data) {
      state.tokenCode = data;
    },
    // 储存我的课程列表的数据
    GET_CourseListRecord(state, data) {
      state.courseListRecord = data;
    },
    // 储存共享课程列表的数据
    GET_SharedListRecord(state, data) {
      state.sharedListRecord = data;
    },
    // 储存课次列表的数据
    GET_ClassListRecord(state, data) {
      state.classListRecord = data;
    },
    // 储存课程详情
    GET_CourseDetails(state, data) {
      state.courseDetails = data;
    },
    // 储存教材详情
    GET_textbookDetails(state, data) {
      state.textbookDetails = data;
    },
    // 储存当前课程课次id
    GET_ClassTimesId(state, data) {
      state.classTimesId = data;
    },
    // 储存资源列表
    GET_ResourceListRecord(state, data) {
      state.resourceListRecord = data;
    },
    // 储存当前选中课程课次资源
    GET_classTimesResources(state, data) {
      state.classTimesResources = data;
    },
    // 储存当前选择题库的数据
    GET_questionBankData(state, data) {
      state.questionBankData = data;
    },
    // 储存作业名称
    GET_testPaperNameData(state, data) {
      state.testPaperNameData = data;
    },
    // 储存作业所属课次
    GET_testPaperClassNumData(state, data) {
      state.testPaperClassNumData = data;
    },
    // 储存资源分类
    GET_resourceType(state, data) {
      state.resourceType = data;
    },
    // 储存首页当前类型
    GET_currentType(state, data) {
      state.currentType = data;
    },
    // 储存线上考试信息
    GET_examinationMessage(state, data) {
      state.examinationMessage = data;
    },
  },
  actions: {},
  modules: {},
});
